<script>
  let { nodes, query, suggestions, index = 0, radius = 3 } = $props()

  // Find the first node ID for each suggested estate name so we don't highlight duplicates
  const highlightedNodeIds = $derived.by(() => {
    const ids = new Set()

    if (index === 7) {
      const namesToHighlight = ['Hougang Capeview', 'Parc Clover @ Tengah', 'Alkaff CourtView']
      namesToHighlight.forEach((name) => {
        const exactMatch = nodes.find((n) => n['bto-name'] === name)
        if (exactMatch) {
          ids.add(exactMatch.id)
        }
      })
    } else if (index === 8) {
      const namesToHighlight = ['Matilda Portico', 'Ghim Moh Natura', 'Belvia', 'The Coris']
      namesToHighlight.forEach((name) => {
        const exactMatch = nodes.find((n) => n['bto-name'] === name)
        if (exactMatch) {
          ids.add(exactMatch.id)
        }
      })
    }

    const isSearchActive = query && query.trim() !== ''
    if (isSearchActive) {
      const trimmedQuery = query.trim().toLowerCase()
      // Highlight only on exact match
      const exactMatch = nodes.find((n) => String(n['bto-name']).toLowerCase() === trimmedQuery)
      if (exactMatch) {
        ids.add(exactMatch.id)
      }
    }

    return ids
  })
</script>

{#each nodes as node (node.id)}
  <circle
    style={`transform: translate(${node.cx}px, ${node.cy}px);`}
    r={radius}
    fill={highlightedNodeIds.has(node.id) ? 'var(--project-highlight-color, #cfff5e)' : '#8aa4d6'}
  />
{/each}
